<template>
  <div class="about-us">
    <h4 class="main-title">{{ $t('manga.about.title') }}</h4>

    <p class="intro">{{ $t('manga.about.intro') }}</p>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.about.missionTitle') }}</h4>
      <p>{{ $t('manga.about.missionContent') }}</p>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.about.coreTitle') }}</h4>

      <div class="subsection">
        <h5 class="subsection-title">{{ $t('manga.about.toolTitle') }}</h5>
        <p>{{ $t('manga.about.toolContent') }}</p>
      </div>

      <div class="subsection">
        <h5 class="subsection-title">{{ $t('manga.about.privacyTitle') }}</h5>
        <p>{{ $t('manga.about.privacyContent') }}</p>
      </div>

      <div class="subsection">
        <h5 class="subsection-title">{{ $t('manga.about.efficientTitle') }}</h5>
        <p>{{ $t('manga.about.efficientContent') }}</p>
      </div>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.about.futureTitle') }}</h4>
      <p>{{ $t('manga.about.futureContent') }}</p>
    </div>

    <div class="footer">
      <p class="thank-you">{{ $t('manga.about.thankYou') }}</p>
      <p class="signature">{{ $t('manga.about.signature') }}</p>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
.about-us {
  color: #cbd5e1;
  line-height: 1.7;
  font-size: 0.95rem;
}

.main-title {
  color: #5eead4;
  font-size: 1.4rem;
  text-align: center;
  margin-bottom: 1.5rem;
  font-weight: 600;
}

.intro {
  margin-bottom: 2rem;
  text-align: center;
  font-style: italic;
  color: #e2e8f0;
  font-size: 1.1rem;
}

.section {
  margin-bottom: 1.8rem;
}

.section-title {
  color: #5eead4;
  font-size: 1.1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  border-left: 3px solid #5eead4;
  padding-left: 0.8rem;
}

.subsection {
  margin-bottom: 1.2rem;
  margin-left: 1rem;
}

.subsection-title {
  color: #a78bfa;
  font-size: 1rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.about-us p {
  margin-bottom: 0.8rem;
  text-align: justify;
}

.footer {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(94, 234, 212, 0.2);
  text-align: center;
}

.thank-you {
  margin-bottom: 0.5rem;
  color: #e2e8f0;
  font-weight: 500;
}

.signature {
  color: #5eead4;
  font-weight: 600;
  font-style: italic;
}

@media (max-width: 500px) {
  .about-us {
    font-size: 0.9rem;
  }

  .main-title {
    font-size: 1.2rem;
  }

  .intro {
    font-size: 1rem;
  }

  .section-title {
    font-size: 1rem;
    padding-left: 0.6rem;
  }

  .subsection {
    margin-left: 0.5rem;
  }

  .subsection-title {
    font-size: 0.95rem;
  }
}
</style>
